import { AxiosError } from 'axios';

import { USERS_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { Note } from '@/types/note.type';
import { ApiResponse } from '@/types/response.type';

const getNotes = async (userId: string): Promise<ApiResponse<Note[]>> => {
  try {
    const response = await apiManager.get(`${USERS_API_URL}/${userId}/notes`);

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default getNotes;
